module.exports = __webpack_public_path__ + "img/region-latin-america.b0cea9a4.png";